// EXPAND.JS
console.log("expand loaded");
document.addEventListener("DOMContentLoaded", function () {
  const expandButton = document.getElementById("expand");
  let isExpanded = false;

  const applyExpandedStyles = () => {
    document.querySelector(".product-description-container").style.gap = "15px";
    document.querySelector(
      ".description-dimensions-weight-manufacturing"
    ).style.display = "flex";
    document.querySelector(".product-title-container").style.display = "block";
    document.querySelector(".sku-expand").style["font-size"] = "11.5px";
    document.querySelector(".expand-plus").style.display = "none";
    document.querySelector(".expand-minus").style.display = "block";
  };

  const applyCollapsedStyles = () => {
    document.querySelector(
      ".description-dimensions-weight-manufacturing"
    ).style.display = "none";
    document.querySelector(".product-title-container").style.display = "none";
    document.querySelector(".sku-expand").style["font-size"] = "13px";
    document.querySelector(".expand-plus").style.display = "block";
    document.querySelector(".expand-minus").style.display = "none";
  };

  // Toggle functionality for below 700px
  expandButton.addEventListener("click", function () {
    if (!isExpanded) {
      applyExpandedStyles();
    } else {
      applyCollapsedStyles();
    }
    isExpanded = !isExpanded;
  });

  // Detect window resizing and apply changes
  const mediaQuery = window.matchMedia("(min-width: 701px)");

  const handleResize = (e) => {
    if (e.matches) {
      // Apply expanded styles when browser is above 700px
      applyExpandedStyles();
      isExpanded = true;
    } else {
      // Automatically collapse styles when below 700px
      applyCollapsedStyles();
      isExpanded = false; // Reset expanded state
    }
  };

  mediaQuery.addListener(handleResize); // Listen for screen size changes
  handleResize(mediaQuery); // Initial check when the page loads
});
//INSTRUCTION-MANUAL.JS
console.log("i.m loaded");
document.addEventListener("DOMContentLoaded", function () {
  var instructionButton = document.getElementById("instruction-manual-button");
  // No instruction-manual button → nothing to wire up.
  if (!instructionButton) return;
  // Never bind the click handler twice to the SAME button. In the PDP-modal path
  // the product scripts can be re-run; a second click listener on one button
  // fires the toggle an even number of times per click — opening then instantly
  // closing it, so the "switch" appears to do nothing and the button looks dead.
  // The button is recreated on every modal open, so this only guards re-init
  // against one element, never blocks a genuinely new button.
  if (instructionButton.dataset.imBound === "1") return;
  instructionButton.dataset.imBound = "1";
  var productImages = document.getElementById("product-images");
  var instructionImages = document.getElementById("instruction-images");
  var imageContainer = document.querySelector(".product-page-scrollable");
  var mobileImageContainer = document.querySelector(
    ".product-page-image-container"
  );
  // Size/lock ONLY the still-image containers — NOT ".media-and-loading-container"
  // (the video wrapper). The toggle sets pointer-events:none on every element in
  // imgSize while the instruction view is open; if videos are in this list that
  // disables their controls, so the user can never press play (the "standard-
  // layout video won't play" bug). Videos keep their default pointer-events and
  // are sized by CSS instead — exactly what the variant layout already does.
  // Scope to .product-page-wrapper: the index/collection grids reuse
  // .img-and-loading-container, so a document-wide select would stomp grid tiles.
  var imageWrapper = document.querySelector(".product-page-wrapper");
  var imgSize = imageWrapper
    ? imageWrapper.querySelectorAll(".img-and-loading-container")
    : [];
  var jpText = instructionButton.querySelector(".jp-font-close");
  var enText = instructionButton.querySelector(
    ".product-page-button-content p:last-child"
  );

  function handleResize() {
    imgSize.forEach((element) => {
      if (instructionImages.style.display === "flex") {
        if (window.innerWidth <= 700) {
          element.style.width = "75%";
        } else {
          element.style.width = "50%";
        }
      } else if (productImages.style.display === "flex") {
        if (window.innerWidth <= 700) {
          element.style.width = "80%";
        } else {
          element.style.width = "75%";
        }
      }
    });
  }

  window.addEventListener("resize", handleResize);

  // No click gating. This layout has only two containers (product + instruction)
  // and the handler is bound once per button, so every click switches cleanly —
  // even mid-load, where the instruction images just show their loader until they
  // decode. Switching is free to happen whenever.
  instructionButton.addEventListener("click", function () {
    if (productImages.style.display === "none") {
      // Pause any playing instruction videos before leaving the view (parity
      // with the variant layout, which already does this).
      instructionImages.querySelectorAll("video").forEach(function (video) {
        video.pause();
      });

      // Show product images and hide instruction images
      productImages.style.display = "flex";

      imgSize.forEach((element) => {
        if (window.innerWidth <= 700) {
          element.style.width = "80%";
        } else {
          element.style.width = "75%";
        }
        element.style.pointerEvents = "all";
      });

      instructionImages.style.display = "none"; // Hide instruction images

      // Reset scroll position for desktop and mobile containers
      imageContainer.scrollTop = 0;
      mobileImageContainer.scrollTop = 0; // Reset scroll for mobile
      if (window.innerWidth <= 700) {
        window.scrollTo(0, 0); // Reset scroll for the entire page on mobile
      }

      // Change button text to "INSTRUCTION MANUAL" (English and Japanese)
      jpText.textContent = "取扱説明";
      enText.textContent = "INSTRUCTION MANUAL";
    } else {
      // Hide product images and show instruction images

      productImages.style.display = "none";

      imgSize.forEach((element) => {
        element.style.width = "50%";
        element.style.pointerEvents = "none";
      });

      instructionImages.style.display = "flex";
      window.addEventListener("resize", handleResize);
      handleResize();

      // Reset scroll position for desktop and mobile containers
      imageContainer.scrollTop = 0;
      mobileImageContainer.scrollTop = 0; // Reset scroll for mobile
      if (window.innerWidth <= 700) {
        window.scrollTo(0, 0);
      }

      // Change button text to "PRODUCT IMAGES" (English and Japanese)
      jpText.textContent = "商品画像";
      enText.textContent = "IMAGES";
    }
  });
});
